import { Button } from "@progress/kendo-react-buttons";
import { checkboxCheckedIcon, checkboxIcon } from "@progress/kendo-svg-icons";
import "./approbationchip.css";
import { setFormModified } from "../../redux/slices/appStateSlice";
import { useDispatch } from "react-redux";
import { useUpdateProduitApprobationMutation } from "../../redux/api/cache";

interface ApprobationChipProps {
    approuveWeb: boolean;
    approuveWebAnglais: boolean;
    item?: any;
    updateData?: (result: any) => void;
    disabled?: boolean;
    setFormKey?: React.Dispatch<React.SetStateAction<number>>;
}

export default function ApprobationChip(props: ApprobationChipProps) {
    const [updateProduit] = useUpdateProduitApprobationMutation();
    const dispatch = useDispatch();

    const handleUpdateProduit = async (approuveWeb: boolean, langue: string) => {
        if (window.confirm(approuveWeb ?
            `En retirant l'approbation de ce produit en ${langue}, le produit sera automatiquement retiré du site web de Tanguay pour cette langue.  Voulez vous continuer ?` :
            `En approuvant ce produit en ${langue}, le produit sera automatiquement publié sur le site web de Tanguay pour cette langue.  Voulez vous continuer ?`)) {
            let result = await updateProduit({
                prod_num: props.item.prod_num, approuve_web: langue === "français" ? !props.item.approuve_web : props.item.approuve_web,
                approuve_web_ang: langue === "anglais" ? !props.item.approuve_web_ang : props.item.approuve_web_ang
            }).unwrap();
            if (result) {
                props.updateData?.(result);
                dispatch(setFormModified(0));
                props.setFormKey?.(formKey => formKey + 1);
            }
        }
    }

    const handleFrancaisClick = () => {
        handleUpdateProduit(props.approuveWeb, "français")
    };

    const handleAnglaisClick = () => {
        handleUpdateProduit(props.approuveWebAnglais, "anglais")
    };

    return <>
        <div className="k-flex-wrap k-d-flex k-gap-1">
            <Button size={"small"} svgIcon={props.approuveWeb ? checkboxCheckedIcon : checkboxIcon} fillMode={props.approuveWeb ? "solid" : "outline"}
                themeColor={"success"} onClick={handleFrancaisClick} style={props.disabled ? { pointerEvents: 'none' } : {}}>Approuvé Français</Button>
            <Button size={"small"} svgIcon={props.approuveWebAnglais ? checkboxCheckedIcon : checkboxIcon} fillMode={props.approuveWebAnglais ? "solid" : "outline"}
                themeColor={"success"} onClick={handleAnglaisClick} style={props.disabled ? { pointerEvents: 'none' } : {}}>Approuvé Anglais</Button>
        </div>
    </>;
}